var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRicLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 939,
    height: 157,
    viewBox: "0 0 939 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0376 2.2534L23.8013 2.23666L26.435 2.23092L235.761 1.77851C272.131 1.69961 284.294 12.2777 283.365 32.1771L283.366 86.0117C283.366 86.3263 283.357 86.6401 283.338 86.9519C284.191 101.491 272.458 114.336 239.736 114.407L71.6096 114.77C62.7919 114.79 55.5725 107.588 55.5725 98.7676V88.3703C55.5725 79.5497 62.7891 74.577 71.6096 74.5584L227.142 74.2217C245.756 73.8635 246.34 42.233 226.948 40.8815L52.9618 41.2579C45.1235 41.4061 42.1068 45.7346 41.5645 52.2075L42.4726 139.98C42.5635 148.799 35.2546 156.033 26.435 156.052L16.0376 156.075C7.21706 156.094 0 148.893 0 140.072V18.3255C0 9.5049 7.21706 2.27253 16.0376 2.2534Z",
    fill: "#0060AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.274 0.481108L551.812 0C520.788 15.5302 425.47 67.5839 368.614 100.529C358.408 106.442 328.322 118.296 329.274 86.0901V0.481108Z",
    fill: "#009EDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M577.963 154.614L355.424 155.095C386.449 139.564 481.766 87.5108 538.622 54.5661C548.828 48.6522 578.914 36.7991 577.963 69.0045V154.614Z",
    fill: "#0060AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624.192 82.2607V16.1833C624.192 7.80986 631.041 0.946691 639.414 0.928518L651.099 0.90317C659.472 0.884997 666.321 7.72043 666.321 16.0924V78.9264V82.1698C666.321 83.2879 666.198 84.3788 665.966 85.43C666.129 102.875 676.018 112.36 690.485 112.699L846.002 112.362V15.7041C846.002 7.33018 852.852 0.467019 861.224 0.448846L872.909 0.423498C881.282 0.405325 888.131 7.2398 888.131 15.6128V112.271L897.38 112.251C923.713 113.532 941.304 123.689 938.755 154.291L690.485 154.827C648.034 151.722 625.56 130.208 624.219 83.1454C624.203 82.8523 624.192 82.5572 624.192 82.2607Z",
    fill: "#0060AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRicLogo);
export default __webpack_public_path__ + "static/media/ricLogo.d963b0d43f4a22e0effed8b502a90eaa.svg";
export { ForwardRef as ReactComponent };